
import { Component, Vue } from "vue-property-decorator";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import FaqSection from "@/components/FaqSection.vue";
import { getItemListJsonLd, injectJsonLd } from "@/utils/seo";

@Component({
  components: { Breadcrumb, FaqSection }
})
export default class BlmMethodology extends Vue {
  relatedServices = [
    { name: "咨询陪跑", url: "/accompany", desc: "6-12个月全程陪伴，将BLM方法论落地到企业战略制定与执行全流程" },
    { name: "光华大增长营", url: "/big-growth-camp", desc: "系统学习BLM科学经营方法论，掌握战略制定五要素与执行四要素" },
    { name: "BLM科学经营科研院", url: "/research-institute", desc: "深入研究BLM方法论的本土化应用，输出行业最佳实践与落地工具" }
  ];

  mounted() {
    injectJsonLd(
      "jsonld-related-services",
      getItemListJsonLd(
        this.relatedServices.map((s) => ({
          name: s.name,
          url: s.url
        }))
      )
    );
  }
  breadcrumbList = [
    { title: "首页", url: "/" },
    { title: "关于光华", url: "/about" },
    { title: "BLM方法论" }
  ];

  faqList = [
    { question: "BLM方法论是什么？", answer: "BLM（Business Leadership Model，业务领先模型）科学经营方法论是光华赋能在IBM业务领先模型基础上本土化创新的企业经营方法论，涵盖战略制定五要素和战略执行四要素，帮助企业打通从战略到执行的全流程。" },
    { question: "BLM方法论适合什么企业？", answer: "适合有一定规模、需要系统提升战略管理能力的成长型企业，尤其适合遇到战略执行难题、需要从经验管理转向科学管理的企业。" },
    { question: "BLM方法论如何落地？", answer: "可通过光华大增长营等课程系统学习，通过咨询陪跑服务在企业实践中落地，也可通过光华EPM企业绩效系统实现数字化管理。" },
    { question: "BLM方法论与分拆对工作法是什么关系？", answer: "BLM方法论解决「做什么」的战略问题，分拆对™工作法解决「怎么做」的执行问题，二者共同构成科学经营™的两大支柱。" }
  ];
}
